// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"628":"component---src-pages-404-ts","815":"component---src-templates-default-plasmic-page-tsx"}[chunkId] || chunkId) + "-" + {"628":"f4249c5d81e3be3d1402","815":"c29a76484f3200abdb35","954":"c5a9d45e3c3d19c0a99e"}[chunkId] + ".js";
};